import { Query } from "../bus/Query";
import type { JsonRecord } from "../../domain/credentials/CredentialServices";

export type CredentialMaterialDto = Readonly<{
  instanceId: string;
  typeId: string;
  material: JsonRecord;
}>;

export class GetCredentialMaterialQuery extends Query<CredentialMaterialDto> {
  constructor(public readonly displayName: string) {
    super();
  }
}
